import { createI18n } from 'vue-i18n'
import { languages, defaultLocale } from './index'
import setWindowSettings from '@/assets/ts/setting'

setWindowSettings()

const locale = window.BUYANDSHIP.settings.current_language

const i18n = createI18n({
	legacy: false,
	locale,
	fallbackLocale: defaultLocale,
	messages: languages,
})

export default i18n
